import axios from 'axios';
import { generateJWTToken } from '@/utils/IMEI';

// 配置接口地址(dev 走 vue.config.js 的 /webapi 代理，生产同源)
export const API_SERVER_URL = '/webapi/scania-hs.do';

// 请求超时(ms)：配置接口挂掉时快速放弃，不卡启动
const REQUEST_TIMEOUT = 2000;

// 独立实例，不走 @/apis/http.js —— 那里的响应拦截器靠业务字段决定返回值，
// 配置接口一旦改字段就会被判成失败
const service = axios.create({
  baseURL: '',
  timeout: REQUEST_TIMEOUT * 2, // 兜底，真正的超时由 withTimeout 控制
  headers: {
    'Content-Type': 'application/json',
  },
});

// 用定时器与请求竞速，超时返回 null
function withTimeout(promise, timeout = REQUEST_TIMEOUT) {
  return new Promise((resolve) => {
    let done = false;
    const timer = setTimeout(() => {
      if (done) { return }
      done = true;
      console.warn('[serverConfig] 配置接口超时');
      resolve(null);
    }, timeout);
    promise.then((res) => {
      if (done) { return }
      done = true;
      clearTimeout(timer);
      resolve(res);
    }).catch((err) => {
      if (done) { return }
      done = true;
      clearTimeout(timer);
      console.warn('[serverConfig] 配置接口失败', err && err.message);
      resolve(null);
    });
  });
}

// 拉取远程下发的接口配置，拿不到返回 null
export async function getApiServerConfig() {
  const token = generateJWTToken();
  const headers = token ? { Authorization: 'Bearer ' + token } : {};
  const res = await withTimeout(service.get(API_SERVER_URL, { headers }));
  if (!res) { return null }
  const data = res.data;
  if (!data || typeof data !== 'object') { return null }
  if (process.env.NODE_ENV === 'development') {
    console.log('[serverConfig] 远程配置', data);
  }
  return data;
}

export default getApiServerConfig;
